import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { Home } from './pages/Home'
import { NewRoom } from './pages/NewRoom'
import { AuthCOntextProvider } from './context/AuthContext'
import { Room } from './pages/Room';
import { AdminRoom } from './pages/AdminRoom';

function App() {
  return (

    <BrowserRouter>
      <AuthCOntextProvider>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/rooms/news" exact component={NewRoom} />
          <Route path="/rooms/:id" component={Room} />
          <Route path="/admin/rooms/:id" component={AdminRoom} />
        </Switch>
      </AuthCOntextProvider>

    </BrowserRouter>

  );
}

export default App;
